import Game from '../game';
import BaseObject, { BaseObjectParams } from '../baseObject';
import Scene from '../scene/scene';
import Music, { MusicParams } from './music';
import DoubleMusic, { DoubleMusicParams } from './doubleMusic';

import { randomInArray } from '../../utils/array';


export interface PlaylistParams extends BaseObjectParams {
  musicsParamsArray: Array<MusicParams | DoubleMusicParams>;
  loop?: boolean;
  shuffle?: boolean;
}

export default class Playlist extends BaseObject implements PlaylistParams {
  musicsParamsArray!: Array<MusicParams | DoubleMusicParams>;
  loop = true;
  shuffle = false;

  musics: Array<Music>;
  currentMusic: Music | undefined;
  currentMusicIndex = 0;

  get scene(): Scene {
    return Game.instance.scene;
  }

  constructor(params: PlaylistParams) {
    super();
    this.applyParams(params);
    this.musics = this.musicsParamsArray.map((param) => {
      if (!('music2Params' in param)) // generic music params
      {
        return new Music({
          ...param,
          loop: false,
        } as MusicParams);
      }
      else // double music params
      {
        return new DoubleMusic({
          ...param,
          loop: false,
        } as DoubleMusicParams);
      }
    });
    // if (this?.scene?.music)
    //   this.scene.music.pause();
    // if (this.scene)
    //   this.scene.music = this;
    if (this.shuffle) {
      this.musics.sort(() => {
        return randomInArray([-1, 1]);
      });
    }
  }

  play(): Music | void {
    this.currentMusic = this.musics[this.currentMusicIndex];
    if (!this.currentMusic)
      return;

    this.currentMusic.play();
    this.currentMusic.getAudio().onended = () => {
      this.playNext();
    };
    return this.currentMusic;
  }

  pause(): Music | undefined {
    this.currentMusic?.pause();
    return this.currentMusic;
  }

  fadeToVolume(volumeToReach = 0, duration = 1000): void {
    this.currentMusic?.fadeToVolume(volumeToReach, duration);
  }

  playNext(): void {
    this.currentMusic = this.getNextMusic();
    if (!this.currentMusic && this.loop)
      this.currentMusicIndex = 0;
    this.play();
  }

  getNextMusic(): Music | undefined {
    return this.musics[++this.currentMusicIndex];
  }
}
